<template lang="pug">
.container-media-player
  .menu-container
    el-button(v-for='medium in media', type='text', size='mini', @click='setMedium(medium)', :key='medium.id')
      span {{  medium.name }}
  .player-container
    .info
      h3.warning(v-if='mediumShown')
        span(v-if='loading') {{ $t(`loading ${mediumShown.name}...`) }}
        span(v-if='!loading') {{ mediumShown.name }}
    FreePlayListPreview(
      v-if='this.tokenParam',
      v-show='!this.loading',
      :width='parseInt(this.$route.params.width)',
      :height='parseInt(this.$route.params.height)',
      :scale='parseFloat(this.$route.params.scale)',
      :tokenParam='this.tokenParam',
      @playerReady='playerReady'
    )
</template>

<script>
import Vue from 'vue'
import FreePlayListPreview from './FreePlayListPreview'
export default {
  components: {
    FreePlayListPreview
  },
  async created () {
    console.log('created', this.$route.params)
    try {
      this.media = (await Vue.axios.post(`medium/getMediaWithPreview`, { Network: this.$route.params.network })).data
    } catch (error) {
      this.error = error.response.data
    }
  },
  data () {
    return {
      error: undefined,
      media: [],
      tokenParam: undefined,
      loading: false,
      mediumShown: undefined
    }
  },
  methods: {
    setMedium (medium) {
      this.tokenParam = undefined
      this.mediumShown = medium
      this.loading = true
      setTimeout(() => {
        this.tokenParam = medium.previewToken
      }, 300)
    },
    playerReady () {
      this.loading = false
    }
  },
  computed: {
  }
}
</script>
<style lang="scss">
@import "../../../theme-m4b/src/common/var.scss";
.container-media-player {
  display: flex;
  .menu-container {
    display: flex;
    flex-direction: column;
    width: 300px;
    margin-top: 50px;
    margin-left: 25px;
    .el-button {
      margin: 0;
      text-align: left;
    }
  }
  .player-container {
    .info {
      text-align: center;
      height: 40px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Medium/FreeMediaPreview.vue